/** Sessie 171: een `<retour>`-blok is een opdracht aan de server en komt
 *  nooit in beeld, ook niet half. Vangnet naast het filter in de backend:
 *  een heel blok weg, een open blok tot het einde weg, en een begonnen
 *  tag aan het einde (`<ret`) weg. */
export function zonderRetourBlok(tekst: string): string {
  if (!/<\/?r/i.test(tekst)) return tekst;
  return tekst
    .replace(/<retour(?=[\s>/])[^<>]*>[\s\S]*?<\/retour\s*>/gi, "")
    .replace(/<retour(?=[\s>/])[^<>]*>[\s\S]*$/i, "")
    .replace(/<\/retour\s*>/gi, "")
    .replace(/<\/?(?:r|re|ret|reto|retou|retour)$/i, "");
}
